import { ApiController } from '@/services/ApiController';
import { ApiRoutes } from '@/enums/api/ApiRoutes';
import { AxiosResponse } from 'axios';

export default class OutboundSyncLogAPI {
  public static async getAll() {
    let outboundSyncLogs;
    try {
      outboundSyncLogs = (await ApiController.get(ApiRoutes.outboundSyncLog.get)) as AxiosResponse;
    } catch (e) {
      return Promise.reject(e);
    }
    return Promise.resolve(outboundSyncLogs);
  }
}